export const stringToBytes = (string) => {
  var array = new Uint8Array(string.length);
  for (var i = 0; i < string.length; i++) {
    array[i] = string.charCodeAt(i);
  }
  return array.buffer;
}